/*
 * Geometry for what this molecule still draws itself. Label, hint, error and
 * control spacing now come from Nuxt UI's FormField, reached through
 * app/design-system/base/VendorFormField.base.vue.
 */
.indicator {
  display: inline-block;
  height: var(--size-ds-indicator);
  width: var(--size-ds-indicator);
  border-radius: var(--radius-ds-pill);
  flex-shrink: var(--flex-ds-shrink-none);
}
